// Recovered compiled webpack factory 36552. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    let { moduleIds: t } = e;
    return null;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "PreloadChunks", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(95155),
    r(47650),
    r(8567),
    r(77278));
}
